import { useState } from "react";
import { Button, Container, Grid, MenuItem, TextField, Typography } from "@mui/material";
import CustomBreadcrumbs from "../../../../components/breadcrumbs";
import SectionTitle from "../../../../components/sectionTitle";
import QUDProgress from "../../../../components/progress";
import ResponseComponent from "../../../../components/responseComponent";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { createModifierGroup } from "../../../../controllers/company/products/ModifierGroupController";

export default function ModifierGroupsCreate()
{
    const [name,setName] = useState('');
    const [errorName,setErrorName] = useState(false);

    const [selectionType,setSelectionType] = useState('');
    const [errorSelectionType,setErrorSelectionType] = useState(false);

    const [required,setRequired] = useState(false);
    const [errorRequired,setErrorRequired] = useState(false);

    const [isLoading,setIsLoading] = useState(false);

    const [open,setOpen] = useState(false);
    const [title,setTitle] = useState('');
    const [message,setMessage] = useState('');
    const [success,setSuccess] = useState(false);

    const history = useHistory();
    

    const formVerification = () => {
        let ban = 0;

        if(name === '')
        {
            setErrorName(true);
            ban = 1;
        }

        if(selectionType === '')
        {
            setErrorSelectionType(true);
            ban = 1;
        }

        return ban;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if(formVerification()===0)
        {
            setIsLoading(true);
            const response = await createModifierGroup(name,selectionType);
            if(response.success === true)
            {
                setTitle('Operación Exitosa');
                setMessage(response.message);
                setSuccess(true);
                setOpen(true);
            }
            else
            {
                setTitle('Operación Fallida');
                setMessage(response.message);
                setSuccess(false);
                setOpen(true);
            }

            setIsLoading(false);
        }
    }

    const handleClose = () => {
        setOpen(false);
        if(success === true)
        {
            history.push('/products/modifiergroups');
        }
    }

    return(
        <Container maxWidth='xl'>
            <CustomBreadcrumbs
                returnTo='/products/modifiergroups'
                crumbs={[
                    {name:'Productos',link:'/products'},
                    {name:'Extras',link:'/products/modifiergroups'},
                    {name:'Crear grupo',link:'/products/modifiergroups/create'}]}
                />
            <br/>
            <SectionTitle title='Crear Grupo' subtitle={'(Extras)'} />

            <Grid container spacing={3} justifyContent={'center'}>
                <Grid item lg={4} xl={4}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TextField
                                label='Nombre'
                                fullWidth
                                value={name}
                                onChange={(e)=>setName(e.target.value)}
                                onBlur={()=>setErrorName(name==='')}
                                error={errorName}
                                helperText={errorName?<Typography>El nombre es obligatorio</Typography>:''}
                            />
                            <Typography style={{fontSize: 16, color: 'gray', marginTop: 4}}>
                                El nombre de la categoría para tus extras. 
                                Ej: 'Accesorios', 'Garantía Extendida', 'Ajustes de Ropa', 'Salsas'.
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                select
                                id="selectionType"
                                name='selectionType'
                                label="Tipo de selección"
                                variant="outlined"
                                value = {selectionType}
                                onChange={(e)=>setSelectionType(e.target.value)}
                                onBlur={()=>setErrorSelectionType(selectionType==='')}
                                error = {errorSelectionType}
                                helperText={errorSelectionType && 'El tipo de selección es obligatorio'}
                            >
                                <MenuItem value=''>Tipo de selección</MenuItem>
                                <MenuItem value={'single'}>Único</MenuItem>
                                <MenuItem value={'multiple'}>Múltiple</MenuItem>
                            </TextField>
                            <Typography style={{fontSize: 16, color: 'gray', marginTop: 4}}>
                                Controla cómo el cliente puede elegir las opciones de este grupo:
                                <br/>- Único: El cliente solo puede seleccionar una opción (ideal para "Punto de Cocción" o "Tipo de Garantía").
                                <br/>- Múltiple: El cliente puede seleccionar varias opciones a la vez (ideal para "Toppings" o "Accesorios").
                            </Typography>
                        </Grid>

                        {/*<Grid item xs={12}>
                            <TextField
                                fullWidth
                                select
                                id="required"
                                name='required'
                                label="Obligatorio"
                                variant="outlined"
                                value = {required}
                                onChange={(e)=>setRequired(e.target.value)}
                                onBlur={()=>setErrorRequired(required==='')}
                                error = {errorRequired}
                                helperText={errorRequired && 'El tipo de selección es obligatorio'}
                            >
                                <MenuItem value=''>Tipo de selección</MenuItem>
                                <MenuItem value={'0'}>Singular</MenuItem>
                                <MenuItem value={'1'}>Multiple</MenuItem>
                            </TextField>
                            <Typography style={{fontSize: 16, color: 'gray', marginTop: 4}}>
                                Define si el cliente obligatoriamente debe seleccionar una opción del grupo.
                            </Typography>
                        </Grid>*/}
                    </Grid>
                    
                    <Button
                        fullWidth
                        variant="contained"
                        sx={{mt:2}}
                        onClick={(e)=>handleSubmit(e)}
                    >
                        <Typography>Crear grupo</Typography>
                    </Button>

                    {/*<TextField
                                            fullWidth
                                            select
                                            id="idUnidad"
                                            name='idUnidad'
                                            label="Unidad de medida"
                                            variant="outlined"
                                            value = {idUnidad}
                                            onChange = { onChange }
                                            onBlur={ () => (idUnidad === '' ? setState({field:'errorIdUnidad',value:true}) : setState({field:'errorIdUnidad',value:false}) ) }
                                            error = {errorIdUnidad}
                                            helperText={errorIdUnidad && 'Seleccione la unidad de medida'}
                                        >
                                            <MenuItem value=''>Seleccione una unidad</MenuItem>
                                            {
                                                unidades.length !== 0 &&
                                                unidades.map((item)=>
                                                    <MenuItem value={item.idUnidad}>{item.nombre}</MenuItem>
                                                )
                                            }
                                        </TextField>*/}
                </Grid>
            </Grid>

            <QUDProgress open={isLoading}/>
            <ResponseComponent
                show={open}
                success={success}
                title={title}
                message={message}
                actionText={'Finalizar'}
                onClick={()=>handleClose()}
            />
        </Container>
    )
}